var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0868 12.7057H4.75342C4.48008 12.7057 4.25342 12.4791 4.25342 12.2057C4.25342 11.9324 4.48008 11.7057 4.75342 11.7057H10.0868C11.6468 11.7057 12.9201 10.4324 12.9201 8.8724C12.9201 7.3124 11.6468 6.03906 10.0868 6.03906H2.75342C2.48008 6.03906 2.25342 5.8124 2.25342 5.53906C2.25342 5.26573 2.48008 5.03906 2.75342 5.03906H10.0868C12.2001 5.03906 13.9201 6.75906 13.9201 8.8724C13.9201 10.9857 12.2001 12.7057 10.0868 12.7057Z",
    fill: "#757575"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28654 7.70659C4.15988 7.70659 4.03321 7.65992 3.93321 7.55992L2.22654 5.85326C2.03321 5.65992 2.03321 5.33992 2.22654 5.14659L3.93321 3.43992C4.12654 3.24659 4.44654 3.24659 4.63988 3.43992C4.83321 3.63326 4.83321 3.95326 4.63988 4.14659L3.28654 5.49992L4.63988 6.85326C4.83321 7.04659 4.83321 7.36659 4.63988 7.55992C4.54654 7.65992 4.41321 7.70659 4.28654 7.70659Z",
    fill: "#757575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.5b3959bc.svg";
export { ForwardRef as ReactComponent };